import { render, staticRenderFns } from "./VScode.vue?vue&type=template&id=1188f748&scoped=true&"
import script from "./VScode.vue?vue&type=script&lang=js&"
export * from "./VScode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1188f748",
  null
  
)

export default component.exports